import RNLayoutGuides from 'react-native-layout-guides'

export default RNLayoutGuides

export const DEFAULT_LAYOUT_GUIDES = { top: 0, bottom: 0 }
